// extracted by mini-css-extract-plugin
export var firstGlow = "styles-module--first-glow--29eaf";
export var subtitle = "styles-module--subtitle--f3c03";
export var suptitle = "styles-module--suptitle--ada5c";
export var title = "styles-module--title--900a3";